exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dashboardAERTotalHeader-8c77d{display:flex;justify-content:flex-end;margin-bottom:5px}.dashboardAERTotalHeader-8c77d span{width:30%;text-align:center;font-weight:500}", ""]);

// Exports
exports.locals = {
	"dashboardAERTotalHeader": "dashboardAERTotalHeader-8c77d"
};